export const CURRENT_VERTICAL = process.env.VUE_APP_CURRENT_VERTICAL || ""

export const DESKTOP_BREAKPOINT = "992"

export const DEFAULT_TOAST_DURATION = 3000

export const DEFAULT_REVIEW_TRUNCATE_LINES = 3

export const DEFAULT_REVIEW_TRUNCATE_CHARS = 150

export const DEFAULT_IMAGE_TYPE_SUPPORT = ["JPEG", "PNG", "JPG"]

export const FYND_DEFAULT_HEADER_CLASSNAME = "ct-header-wrapper"

export const BINDING_TYPE = {
  REVIEW_AND_RATING: "review_and_rating",
  AVERAGE_RATING: "avg_rating",
  QUESTION_AND_ANSWER: "question_and_answer",
}

export const BINDING_ELEMENT_ID = {
  REVIEW_AND_RATING: "rnr-widget",
  AVERAGE_RATING: "rnr-avg-widget",
  QUESTION_AND_ANSWER: "qna-widget",
}
